// Ambiente da interface e destino de entrega são configurações independentes.
export function obterAmbienteAplicacao(valor) {
    const codigo = String(valor || "")
        .trim()
        .toUpperCase();
    const ambientes = {
        LOCAL: ["Local", "info"],
        HOM: ["Homologação (HOM)", "warning"],
        DEV: ["Desenvolvimento (DEV)", "info"],
        MOCK: ["Simulação (MOCK)", "info"],
        PROD: ["Produção (PROD)", "error"],
        PRD: ["Produção (PRD)", "error"],
        PRODUCTION: ["Produção (PRODUCTION)", "error"]
    };
    const [rotulo, cor] = ambientes[codigo] || [
        "Ambiente não identificado",
        "default"
    ];
    return {codigo, rotulo, cor};
}

export function ambientePermiteAutorizacao(valor) {
    return ["HOM", "MOCK"].includes(obterAmbienteAplicacao(valor).codigo);
}

export function obterModoEnvio(configuracao, {isLoading, isError} = {}) {
    if (isError)
        return {
            rotulo: "Indisponível",
            cor: "error",
            descricao:
                "Não foi possível consultar a configuração atual. Atualize o status do sistema."
        };
    if (isLoading || !configuracao)
        return {
            rotulo: "Consultando",
            cor: "default",
            descricao:
                "Aguardando a configuração de entrega informada pelo backend."
        };
    if (
        configuracao.enabled === false ||
        configuracao.destino === "DESABILITADO"
    ) {
        return {
            rotulo: "Desabilitado",
            cor: "default",
            descricao:
                "A entrega externa está desabilitada na configuração do backend."
        };
    }
    if (configuracao.destino === "ESFINGE_DIRETO") {
        return {
            rotulo: "e-Sfinge direto",
            cor: "primary",
            descricao:
                "O conector transmite diretamente ao e-Sfinge. O aceite é acompanhado pelo retorno do TCE-MS."
        };
    }
    if (configuracao.destino === "FORNECEDOR") {
        const simulacao = configuracao.fornecedorAdaptador === "MOCK";
        return {
            rotulo: simulacao ? "Fornecedor · simulação (MOCK)" : "Fornecedor",
            cor: simulacao ? "warning" : "info",
            descricao: simulacao
                ? "O recebimento pelo fornecedor é simulado. Não comprova transmissão ao TCE-MS."
                : "O conector entrega ao fornecedor. O aceite oficial do TCE-MS é conferido separadamente."
        };
    }
    return {
        rotulo: "Não identificado",
        cor: "warning",
        descricao:
            "A configuração recebida não identifica um destino de entrega conhecido."
    };
}

export function nomeAplicacaoNeutro(nome) {
    return [
        "e-Sfinge Homologação Controlada",
        "e-Sfinge Mock Atos de Pessoal",
        "DPGE <-> E-SFINGE"
    ].includes(nome)
        ? "Conector e-Sfinge"
        : nome || "Conector e-Sfinge";
}
